import {
    put
} from 'redux-saga/effects';
import { takeFirst } from './helperSaga';
import { ACTIONS } from '../actions/actionTypes';
import * as game from '../controllers';
import PlaySound from '../sounds/playSound';
import errorCatcher from '../utils/errorCatcher';

export function * GET_DASHBOARD () {
    yield takeFirst(ACTIONS.GET_DASHBOARD, function * (action) {
        try {
            const dashboardData = yield game.dashboard.get();
            yield put({type: ACTIONS.USER_UPDATE_LOCAL_DATA, payload: dashboardData.user});
            yield put({type: ACTIONS.USER_SET_WHATSNEXT, payload: dashboardData.whatsNext});
            yield put({type: ACTIONS.DASHBOARD_SET_NEW_MESSAGES, payload: dashboardData.notificationsQtt});
            yield put({type: ACTIONS.SET_MISSIONS, payload: dashboardData.whatsNext.nextMissions});
            if (dashboardData.notificationsQtt > 0) {
                PlaySound('newMessage');
            }
        } catch (err) {
            errorCatcher(err);
        }
    });
}

export function * GET_SCHOOLS () {
    yield takeFirst(ACTIONS.GET_SCHOOLS, function * (action) {
        try {
            const schools = yield game.school.get();
            if (schools) {
                yield put({type: ACTIONS.GET_SCHOOLS, payload: schools});
            }
        } catch (err) {
            errorCatcher(err);
        }
    });
}

export function * GET_COURSES () {
    yield takeFirst(ACTIONS.GET_COURSES, function * (action) {
        try {
            yield put({type: ACTIONS.GET_COURSES_LOADING, payload: true});
            const areas = action.payload.map((item) => (typeof item === 'object' ? item._id : item));
            const courses = yield game.courses.get(areas.join(','));
            if (courses) {
                yield put({type: ACTIONS.GET_COURSES, payload: courses});
                yield put({type: ACTIONS.GET_COURSES_LOADING, payload: false});
            }
        } catch (err) {
            errorCatcher(err);
        }
    });
}

export function * GET_MISSIONS () {
    yield takeFirst(ACTIONS.GET_MISSIONS, function * (action) {
        try {
            yield put({type: ACTIONS.GET_MISSIONS_LOADING, payload: true});
            const missions = yield game.missions.get();
            if (missions) {
                yield put({type: ACTIONS.GET_MISSIONS, payload: missions});
                yield put({type: ACTIONS.GET_MISSIONS_LOADING, payload: false});
            }
        } catch (err) {
            errorCatcher(err);
        }
    });
}

const parameterizeArray = (key, arr) => {
    arr = arr.map(encodeURIComponent);
    return key + '=' + arr.join('&' + key + '=');
}
;



// WEBPACK FOOTER //
// ./src/sagas/fetchSaga.js